import {React, useContext, useState} from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import {useStyle} from '../../context/styleContext/styleContext'
import{UserContext} from '../../context/userContext/userContext'
import LoginSubscribePromptModal from '../LoginSubscribePromptModal/LoginSubscribePromptModal';

export default function SubscribeBanner() {

    const [loginPromptOpen, setLoginPromptOpen] = useState(false);

    const closeModal = () => {
        setLoginPromptOpen(false);
    }

  const handleSubscribe = () => {

    console.log(user)
    console.log("EMAIL")
    console.log(userEmail)
    if(!userEmail)
    {
        setLoginPromptOpen(true);
    }
    if(userEmail)
    {
        window.location.href = `https://buy.stripe.com/6oE3gfaAxdanaticMM?prefilled_email=${encodeURIComponent(userEmail)}`;
    }

  };


  const { style, setStyle } = useStyle();

  const { user, setUser, userEmail, userFirstName, userLastName } = useContext(UserContext);

  return (<>
    <Paper
      elevation={6}
      sx={{
         backgroundColor: 'rgb(18, 18, 18)',
        //backgroundColor:'black',
        color: style.color4,
        p: 1,
        textAlign: 'center',
        flex:1,
        margin: 'auto',
        border: `2px solid rgb(45,45,45)`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>

        <h1 style={{ color: style.color4, fontSize:'1.6em' }}>
          All Access Pass - 7 day <strong>FREE</strong> trial
        </h1>

      </Box>

        <p>
            Get access to all plugins for just <strong>$9.95/month</strong>, cancel anytime.
        </p>

      <Button
        onClick={handleSubscribe}
        variant="contained"
        size="small"
        sx={{
          backgroundColor: style.color1,
          color: style.color4,
          fontWeight: 'bold',
          fontSize:'16pt',
          px:4,
          '&:hover': {
            backgroundColor: style.color3,
          },
        }}
      >
        Subscribe Now
      </Button>
    </Paper>
     <div id='modal-root'>
     <LoginSubscribePromptModal isOpen={loginPromptOpen} close={closeModal} />
         
 </div></>
  );
}
